import React, { useState, useEffect } from 'react';
import env from 'src/env';
import {
  IntercomCustomLauncher,
  IntercomIconOpen,
  IntercomIconClose,
} from './styles';
import './hideDefaultLauncher.css';

const intercomAppIds = {
  STAGING: 'p36rgy9q',
  PRODUCTION: 'arfbt5q9',
};

declare global {
  interface Window {
    Intercom?: any;
  }
}

interface User {
  first_name: string;
  last_name: string;
  email: string;
  intercom_sha: string;
  id: number;
}

interface Props {
  user: User;
}

const IntercomLauncher: React.FunctionComponent<Props> = (props) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [isIntercomOpen, setIsIntercomOpen] = useState<boolean>(false);
  const [isIntercomBooted, setIsIntercomBooted] = useState<boolean>(false);
  const appId =
    env.APP_ENVIRONMENT === 'production'
      ? intercomAppIds.PRODUCTION
      : intercomAppIds.STAGING;

  const handleShow = () => setIsIntercomOpen(true);
  const handleHide = () => setIsIntercomOpen(false);
  const handleUnreadCountChange = (count: number) => setUnreadCount(count);

  // set Intercom event listeners
  useEffect(() => {
    window.Intercom('onShow', handleShow);
    window.Intercom('onHide', handleHide);
    window.Intercom('onUnreadCountChange', handleUnreadCountChange);
  }, []);

  // boot Intercom with user information
  useEffect(() => {
    const { user } = props;
    if (!user) {
      return;
    }
    /*
     * For more information see here:
     * https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app
     */
    window.Intercom('boot', {
      app_id: appId,
      name: `${user.first_name} ${user.last_name}`,
      user_id: user.id,
      user_hash: user.intercom_sha,
      email: user.email,
      custom_launcher_selector: '#intercom-custom-launcher',
    });

    setIsIntercomBooted(true);
  }, [props.user]);

  return (
    <IntercomCustomLauncher
      id="intercom-custom-launcher"
      size="28px"
      isIntercomBooted={isIntercomBooted}
      data-selenium="designProIntercomLauncherButton"
    >
      <IntercomIconOpen isIntercomOpen={isIntercomOpen} />
      <IntercomIconClose isIntercomOpen={isIntercomOpen} />
      <span>{unreadCount > 0 ? unreadCount : ''}</span>
    </IntercomCustomLauncher>
  );
};

export default IntercomLauncher;
